import React, { useState, useContext, useRef } from 'react'
import './M_Button.css'
import { Tooltip } from '@mui/material'
import { MTable, MElementDrawer, LoadingContext, } from '../../M_Components'
import { useTranslation } from "react-i18next"
import PropTypes from 'prop-types'

export function MButton({
    onClick, borderColor, backgroundColor, label, icon, labelColor,
    iconPosition, smallIcon, largeIcon, bold, hoverEffect, tooltip,
    id, width, height, borderRadius, normal, large, none, marginLeft,
    marginRight, marginTop, marginBottom, type, disabled, onGetline,
    FILTER, entity, errorMessage, tableLabel, element, disableFunction,
    inputType, onInput, marginNone, noHover, multiple, onSubmitValue,
    value, valueIdField, cy
}) {
    const { t } = useTranslation()
    const [onOpen, setOnOpen] = useState(false)
    const ctx = useContext(LoadingContext)
    const inputRef = useRef(null)

    const newBorder = borderColor ? `1px solid ${borderColor}` : '0px'
    const newBackgroundColor = backgroundColor || "var(--color-white)"
    const newColor = labelColor || "var(--color-black)"
    const newBold = bold ? "bold" : ""
    const newBorderColor = borderRadius ? `${borderRadius}px` : "5px"

    function iconSize() {
        if (smallIcon) {
            return '.5'
        }
        return largeIcon ? '1.5' : '1'
    }

    function divImg() {
        if (icon)
            return (
                <i style={{
                    marginLeft: '5px',
                    marginRight: '5px',
                    scale: iconSize()
                }}>
                    {icon}
                </i>
            )
    }

    const buttonClick = () => {
        if (disabled !== undefined && disabled !== null) {
            if (disableFunction()) return ctx.toastMessages('error', errorMessage, '')
            return openDrawer()
        }
        return openDrawer()
    }

    const getLine = (e) => {
        if (!multiple) {
            onGetline(e[0])
            closeDrawer()
        }
    }

    const openDrawer = () => {
        setOnOpen(true)
    }

    const closeDrawer = () => {
        setOnOpen(false)
    }

    const clickFunction = (event) => {
        if (disabled) return null
        if (entity || element) return buttonClick()
        if (inputType) return handleClickInput()
        return onClick(event)
    }

    function paddingSize() {
        if (normal) return '0px 10px'
        if (large) return '5px 15px'
        if (none) return '0px 0px'
        if (width && height) return `${height}px ${width}px`
        if (width) return `0px ${width}px`
        if (height) return `${height}px 0px `
        return '0px 5px'
    }

    function marginValues(marginSide) {
        return marginSide ? `${marginSide}px` : isMarginNone()
    }

    function isMarginNone() {
        if (marginNone) return '0px'
        return '5px'
    }

    const styledButtons = {
        padding: paddingSize(),
        border: newBorder,
        backgroundColor: newBackgroundColor,
        color: newColor,
        fontWeight: newBold,
        borderRadius: newBorderColor,
        marginLeft: marginValues(marginLeft),
        marginRight: marginValues(marginRight),
        marginTop: marginValues(marginTop),
        marginBottom: marginValues(marginBottom),
    }

    const styledLabel = {
        marginTop: marginNone ? '0px' : '10px',
        marginBottom: marginNone ? '0px' : '10px',
        marginLeft: marginNone ? '0px' : '5px',
        marginRight: marginNone ? '0px' : '5px',
    }

    const disableStyledButtons = {
        boxShadow: 'inset 100px 100px 10px var(--color-grey-light)'
    }

    const handleClickInput = () => {
        inputRef.current.click()
    }

    const onSave = (e) => {
        onSubmitValue(e)
        closeDrawer()
    }

    function setClassName() {
        if (disabled) return "buttonClass2"
        if (hoverEffect) return "buttonClass buttonClassHover hoverEffect"
        if (noHover) return "buttonClass"
        return "buttonClass buttonClassHover"
    }

    function componentButton() {
        return (
            <button
                data-cy={cy}
                id={id}
                draggable={false}
                onDragStart={(event) => event.preventDefault()}
                disabled={disabled}
                type={type}
                onClick={clickFunction}
                style={disabled ? { ...styledButtons, ...disableStyledButtons } : styledButtons}
                className={setClassName()}
            >
                {!iconPosition || iconPosition.toUpperCase() === 'LEFT' ? divImg() : ''}
                {label && <span className='fontSizeLabel' style={styledLabel} >{label}</span>}
                {iconPosition && iconPosition.toUpperCase() === 'RIGHT' ? divImg() : ''}
            </button>)
    }

    // Base button element used in both tooltip and non-tooltip branches
    const buttonElement = componentButton();

    return (
        <div key={id}>
            {tooltip ? (
                <Tooltip title={tooltip}>
                    {/* 
                      Wrap the button in a span so Tooltip does not receive
                      a disabled <button> directly. Disabled elements do not
                      fire mouse events, but the span will, so the tooltip
                      still works without warnings.
                    */}
                    <span
                        style={{
                            display: 'inline-flex',
                            cursor: disabled ? 'not-allowed' : 'pointer',
                        }}
                    >
                        {buttonElement}
                    </span>
                </Tooltip>
            ) : (
                buttonElement
            )}

            {entity && (
                <MElementDrawer
                    element={
                        <div className='divTableDrawer' style={{}}>
                            <h2
                                style={{
                                    marginLeft: '10px',
                                    marginTop: '0px',
                                    marginBottom: '10px',
                                }}
                            >
                                {tableLabel}
                            </h2>
                            <MTable
                                removeHeaders={['IMAGE']}
                                tableHeight={'80vh'}
                                entityName={entity}
                                useSessionStorage={false}
                                crud={false}
                                onPassLine={getLine}
                                selectSingle={multiple ? !multiple : true}
                                FILTER={FILTER}
                                value={value}
                                valueIdField={valueIdField}
                                extraButtons={
                                    multiple && [
                                        {
                                            label: t('Save'),
                                            element: 'default',
                                            icon: (
                                                <img
                                                    src="./icons/svgsDaNet/save.svg"
                                                    style={{
                                                        filter:
                                                            'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)',
                                                        width: '24px',
                                                    }}
                                                    alt="save"
                                                />
                                            ),
                                            command: (e) => onSave(e),
                                        },
                                    ]
                                }
                            />
                        </div>
                    }
                    tableLabel={tableLabel || ''}
                    entity={entity}
                    open={onOpen}
                    setOpen={setOnOpen}
                    onClose={closeDrawer}
                    onSelectLine={getLine}
                    FILTER={FILTER}
                />
            )}

            {inputType && (
                <input
                    data-testid="input-field"
                    disabled={disabled}
                    type={inputType}
                    ref={inputRef}
                    onChange={onInput}
                    style={{ display: 'none' }}
                />
            )}

            {element && (
                <div data-testid="custom-element">
                    <MElementDrawer
                        open={onOpen}
                        setOpen={setOnOpen}
                        onClose={closeDrawer}
                        element={element}
                    />
                </div>
            )}
        </div>
    );
}

MButton.propTypes = {
    onClick: PropTypes.func,
    borderColor: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
    ]),
    backgroundColor: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
    ]),
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
    ]),
    icon: PropTypes.element,
    labelColor: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
    ]),
    iconPosition: PropTypes.oneOf(['left', 'right']),
    smallIcon: PropTypes.bool,
    largeIcon: PropTypes.bool,
    bold: PropTypes.bool,
    hoverEffect: PropTypes.bool,
    tooltip: PropTypes.string,
    id: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    borderRadius: PropTypes.number,
    normal: PropTypes.bool,
    large: PropTypes.bool,
    none: PropTypes.bool,
    marginLeft: PropTypes.number,
    marginRight: PropTypes.number,
    marginTop: PropTypes.number,
    marginBottom: PropTypes.number,
    type: PropTypes.string,
    disabled: PropTypes.bool,
    onGetline: PropTypes.func,
    FILTER: PropTypes.string,
    entity: PropTypes.string,
    errorMessage: PropTypes.string,
    tableLabel: PropTypes.string,
    element: PropTypes.element,
    disableFunction: PropTypes.func,
    inputType: PropTypes.string,
    onInput: PropTypes.func,
    marginNone: PropTypes.bool,
    noHover: PropTypes.bool,
    multiple: PropTypes.bool,
    onSubmitValue: PropTypes.func,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.array
    ]),
    valueIdField: PropTypes.string,
    cy: PropTypes.string
}
